{
    "Capability": "Capacité",
    "CapabilityEnabled": "Activé",
    "AvailableTelServers": "Quels sont les types de serveurs de téléphonie disponibles ?",
    "AvailableLicences": "Quels sont les types de licences de site disponibles ?",
    "Broadworks": "Cisco Broadworks",
    "Webex": "Appels Webex",
    "LegacyTelephony": "Legacy ^^(Broadsoft M6, Panasonic, Siemens)^^",
    "Legacy": "Héritage ^^(ONE, Présence, Lite, 1000, 2000)^^",
    "Enterprise": "Entreprise",
    "Teams": "MS Teams",
    "MaxTelsysCount": "Nombre maximal de serveurs de téléphonie dans ce CME",
    "NAME": "CMECapabilities",
    "CxAnalytics": "Analyse de l'expérience client",
    "CxIntegration": "Intégration CX"
}